import { render, staticRenderFns } from "./Atlas.vue?vue&type=template&id=0d0049d6&"
import script from "./Atlas.vue?vue&type=script&lang=js&"
export * from "./Atlas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports